module.exports = __webpack_public_path__ + "static/media/33.fcbc0f27.mp3";